import React from 'react';
import { Content, Button, Flex, Text, Pane } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import S from './Pair.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('r4k.views.keyTagPairing.TagUnactivated');
export default function TagUnactivated(props) {
  const {
    areaClassName,
    footerClassName,
    titleVariant,
    onOkay: pOnOkay,
    onClose,
    onSetField
  } = props;
  const onOkay = evt => {
    pOnOkay(evt);
    onSetField({
      data: 'tagId',
      value: null
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Content.Header, {
      variant: "formHeader",
      children: /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: t('title'),
        icon: tIcon('titleIcon'),
        children: /*#__PURE__*/_jsx(Button, {
          variant: "closeDialog",
          className: S.close,
          onClick: onClose
        })
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      variant: "formBody",
      className: areaClassName,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsx("img", {
          src: t('tagWarningIcon'),
          alt: "Locator warning",
          height: 80,
          width: 80
        }), /*#__PURE__*/_jsx(Text, {
          variant: "formTitle",
          children: t('tagTitle')
        }), /*#__PURE__*/_jsx(Text, {
          children: t('tagSubtitle')
        }), /*#__PURE__*/_jsx(Pane, {
          variant: "dashboardCard",
          children: /*#__PURE__*/_jsx(Pane, {
            variant: "dataCard",
            children: /*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              children: [/*#__PURE__*/_jsxs(Flex, {
                variant: "rowM",
                children: [/*#__PURE__*/_jsx(Text, {
                  className: S.ordinal,
                  variant: "groupingsCount",
                  children: "1"
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    flexGrow: 1
                  },
                  children: /*#__PURE__*/_jsx(Text, {
                    children: /*#__PURE__*/_jsx("b", {
                      children: t('dataCard1Title')
                    })
                  })
                })]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  flexGrow: 1
                },
                children: /*#__PURE__*/_jsx(Text, {
                  children: t('dataCard1Text')
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Pane, {
          variant: "dashboardCard",
          children: /*#__PURE__*/_jsx(Pane, {
            variant: "dataCard",
            children: /*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              children: [/*#__PURE__*/_jsxs(Flex, {
                variant: "rowM",
                children: [/*#__PURE__*/_jsx(Text, {
                  className: S.ordinal,
                  variant: "groupingsCount",
                  children: "2"
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    flexGrow: 1
                  },
                  children: /*#__PURE__*/_jsx(Text, {
                    children: /*#__PURE__*/_jsx("b", {
                      children: t('dataCard2Title')
                    })
                  })
                })]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  flexGrow: 1
                },
                children: /*#__PURE__*/_jsx(Text, {
                  children: t('dataCard2Text')
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Pane, {
          variant: "dashboardCard",
          children: /*#__PURE__*/_jsx(Pane, {
            variant: "dataCard",
            children: /*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              children: [/*#__PURE__*/_jsxs(Flex, {
                variant: "rowM",
                children: [/*#__PURE__*/_jsx(Text, {
                  className: S.ordinal,
                  variant: "groupingsCount",
                  children: "3"
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    flexGrow: 1
                  },
                  children: /*#__PURE__*/_jsx(Text, {
                    children: /*#__PURE__*/_jsx("b", {
                      children: t('dataCard3Title')
                    })
                  })
                })]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  flexGrow: 1
                },
                children: /*#__PURE__*/_jsx(Text, {
                  children: t('dataCard3Text')
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Text, {
          variant: "link",
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            href: t('readDocsLink'),
            rel: "noreferrer",
            children: t('readDocs')
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Content.Footer, {
      variant: "formButtons",
      className: footerClassName,
      layout: "flex:rowMEnd",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        variant: "secondary",
        children: t('onCancel')
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "button.pairing.unactivatedTagReturnToForm",
        variant: "primary",
        onClick: onOkay,
        children: t('onOkay')
      })]
    })]
  });
}